"use client"

import type React from "react"
import { useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import "./Header.css"

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()
  const token = localStorage.getItem("authToken")
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem("authToken")
    navigate("/auth")
  }

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen)

  const isActive = (path: string) => location.pathname === path

  return (
    <header className="header">
      {/* Left: Logo */}
      <div className="logo-container">
        <Link to="/" className="logo">
          Yuba
        </Link>
      </div>

      {/* Center: Desktop Navigation - Now with better distribution */}
      <nav className="nav desktop-nav">
        <Link to="/ramp" className={`nav-link ${isActive("/ramp") || isActive("/") ? "active" : ""}`}>
          Rampa
        </Link>
        <Link to="/swap" className={`nav-link ${isActive("/swap") ? "active" : ""}`}>
          Swap
        </Link>
        <Link to="/payments" className={`nav-link ${isActive("/payments") ? "active" : ""}`}>
          Pago de Servicios
        </Link>
      </nav>

      {/* Right: Desktop User/Login Button */}
      <div className="desktop-user-menu">
        {token ? (
          <>
            <Link to="/transactions" className="nav-link secondary">
              Transacciones
            </Link>
            <button onClick={handleLogout} className="logout-button">
              Cerrar Sesión
            </button>
          </>
        ) : (
          <Link to="/auth" className="nav-link">
            <button className="login-button">Iniciar Sesión</button>
          </Link>
        )}
      </div>

      {/* Hamburger icon (only visible on mobile) */}
      <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Mobile Navigation (dropdown) */}
      {mobileMenuOpen && (
        <nav className="mobile-nav">
          <Link
            to="/ramp"
            onClick={() => setMobileMenuOpen(false)}
            className={`nav-link ${isActive("/ramp") || isActive("/") ? "active" : ""}`}
          >
            Rampa
          </Link>
          <Link
            to="/swap"
            onClick={() => setMobileMenuOpen(false)}
            className={`nav-link ${isActive("/swap") ? "active" : ""}`}
          >
            Swap
          </Link>
          <Link
            to="/payments"
            onClick={() => setMobileMenuOpen(false)}
            className={`nav-link ${isActive("/payments") ? "active" : ""}`}
          >
            Pago de Servicios
          </Link>
          {token ? (
            <>
              <Link to="/transactions" onClick={() => setMobileMenuOpen(false)}>
                Transacciones
              </Link>
              <button onClick={handleLogout}>Cerrar Sesión</button>
            </>
          ) : (
            <Link to="/auth" onClick={() => setMobileMenuOpen(false)}>
              Iniciar Sesión
            </Link>
          )}
        </nav>
      )}
    </header>
  )
}

export default Header
